// @flow
export const ROOT_ROUTE = '/';
export const CHANNELS_ROUTE = '/channels';
export const SELECTIONS_ROUTE = '/selections';
export const RESULT_RECOMMENDATIONS_ROUTE = '/result-recommendations';
export const SHARES_ROUTE = '/share-result-recommendations';
